/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as o from "react";
import { Popup as i } from "@progress/kendo-react-popup";
import { classNames as a } from "@progress/kendo-react-common";
const r = "bottom", s = "top", m = (t) => {
  const n = t.popupSettings || {}, e = t.dir === "rtl" ? "right" : "left", c = o.useMemo(
    () => ({ horizontal: e, vertical: r }),
    [e]
  ), l = o.useMemo(
    () => ({ horizontal: e, vertical: s }),
    [e]
  );
  return /* @__PURE__ */ o.createElement(o.Fragment, null, t.input, t.button, /* @__PURE__ */ o.createElement(
    i,
    {
      style: {
        ...(n || {}).style,
        direction: t.dir
      },
      ...n,
      anchor: t.popupAnchor,
      anchorAlign: c,
      popupAlign: l,
      show: t.open,
      onOpen: t.onOpen,
      onClose: t.onClose,
      className: a(n.className),
      popupClass: "k-color-picker-popup"
    },
    t.content
  ));
};
m.displayName = "KendoPickerComponent";
export {
  m as Picker
};
